var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScrubber = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v17h17V0Zm16 16H1V1h15Zm-4-7.893V15h1V8.107a1.78 1.78 0 0 0 1.281-1.701c0-.807-.543-1.483-1.281-1.701V2h-1v2.705a1.78 1.78 0 0 0-1.281 1.701c0 .807.543 1.484 1.281 1.701m.5-2.482a.782.782 0 1 1-.002 1.564.782.782 0 0 1 .002-1.564"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.773 5.34h-6v-1h6zM6.773 9.34h-4v-1h4zM9.754 7.34h-7v-1h7zM2.776 11.34h7v1h-7Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScrubber);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scrubber.svg";